import { useEffect, useMemo, useCallback } from 'react';
import { useMutation } from 'react-query';
import { useSpinnerContext } from 'components/spinner/context/SpinnerContext';

// POST, PUT, PATCH, DELETE
export function useCommonMutation({ query, callbacks = {} }) {
  const { action } = useSpinnerContext();
  const { showLoading, hideLoading } = action;

  const mutation = useMutation((params) => query.queryFn(params), callbacks);
  const { mutateAsync, mutate } = mutation;

  const status = useMemo(() => {
    return {
      isLoading: mutation.isLoading,
      isSuccess: mutation.isSuccess,
      isFetching: mutation.isFetching,
      isRefetching: mutation.isRefetching,
      isError: mutation.isError,
      isLoadingError: mutation.isLoadingError,
    };
  }, [
    mutation.isLoading,
    mutation.isSuccess,
    mutation.isFetching,
    mutation.isRefetching,
    mutation.isError,
    mutation.isLoadingError,
  ]);

  const { isLoading, isFetching, isRefetching } = mutation;
  useEffect(() => {
    if (isLoading || isFetching || isRefetching) showLoading();
    else hideLoading();
  }, [isLoading, isFetching, isRefetching, showLoading, hideLoading]);

  const requestAsync = useCallback(
    async (params) => {
      return await mutateAsync(params);
    },
    [mutateAsync],
  );

  const request = useCallback(
    (params) => {
      return mutate(params);
    },
    [mutate],
  );

  return { request, status, requestAsync };
}

export default useCommonMutation;
